import { render } from "./TopBar.vue?vue&type=template&id=e634f122"
import script from "./TopBar.vue?vue&type=script&lang=js"
export * from "./TopBar.vue?vue&type=script&lang=js"
script.render = render

export default script